module.exports = __webpack_public_path__ + "img/logo-dark.8bb3db79.svg";